import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { QueueManagementStrategyOption } from '../models/queue-management-option';
import { queueManagementStrategyOptionSelectors } from '../state/queue-management-option.reducer';

@Component({
   selector: 'ndt-queue-management-strategy-select',
   templateUrl: './queue-management-select.component.html',
   standalone: false,

   providers: [
      {
         provide: LCS_SINGLE_SELECT_OPTIONS,
         useExisting: QueueManagementStrategySelectComponent,
      },
   ],
})
export class QueueManagementStrategySelectComponent
   extends LcsSingleSelectBase<QueueManagementStrategyOption>
   implements OnInit
{
   queueManagementStrategies: Observable<QueueManagementStrategyOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.queueManagementStrategies = this.store.pipe(
         select(queueManagementStrategyOptionSelectors.selectFilteredItems),
         this.itemsLoaded()
      );
   }

   displayWith(item: QueueManagementStrategyOption | null): string | null {
      if (!item?.queueManagementStrategyTypeId) return null;

      return item.queueManagementStrategyTypeId.replace(/([a-z])([A-Z])/g, '$1 $2');
   }

   trackBy(item: QueueManagementStrategyOption | null) {
      return item?.queueManagementStrategyTypeId ?? null;
   }
}
